// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-catalog-demand[data-v-8fe18eca]{max-width:346px;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = exports;
